var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file MultiSelectInputItem组件
 * @author (wangzichuan)
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash-es';

/**
 * 参数说明
 * itemObj               数据
 * cancelOnClick         取消点击的回调函数
 */

var MultiSelectInputItem = function (_PureComponent) {
    _inherits(MultiSelectInputItem, _PureComponent);

    function MultiSelectInputItem(props) {
        _classCallCheck(this, MultiSelectInputItem);

        var _this = _possibleConstructorReturn(this, (MultiSelectInputItem.__proto__ || Object.getPrototypeOf(MultiSelectInputItem)).call(this, props));

        _this.cancelOnClick = function (e) {
            e.stopPropagation();
            var _this$props = _this.props,
                itemObj = _this$props.itemObj,
                cancelOnClick = _this$props.cancelOnClick;

            _.isFunction(cancelOnClick) && cancelOnClick(itemObj);
        };

        _this.state = { isShowTitle: false };
        _this.updateIsShowTitle = false;
        return _this;
    }

    _createClass(MultiSelectInputItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showTitle();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.itemObj.title, this.props.itemObj.title)) {
                this.updateIsShowTitle = true;
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.updateIsShowTitle) {
                this.updateIsShowTitle = false;
                this.showTitle();
            }
        }
    }, {
        key: 'showTitle',
        value: function showTitle() {
            if (this.item.scrollWidth > this.item.clientWidth) {
                this.setState({ isShowTitle: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var title = this.props.itemObj.title;
            return React.createElement(
                'div',
                {
                    className: 'input-multi-item',
                    ref: function ref(el) {
                        _this2.item = el;
                    },
                    title: this.state.isShowTitle ? title : undefined
                },
                title,
                React.createElement('i', { className: 'multi-item-cancel', onClick: this.cancelOnClick })
            );
        }
    }]);

    return MultiSelectInputItem;
}(PureComponent);

MultiSelectInputItem.propTypes = {
    itemObj: PropTypes.object,
    cancelOnClick: PropTypes.func
};
export default MultiSelectInputItem;